<template>
  <div
    ref="stacked_bar_percent_chart_div"
    style="width: 100%; height: 220px"
  ></div>
</template>

<script>
export default {
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    translate_key: {
      type: String,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_sbp",
    },
    category: {
      type: String,
      required: false,
    },
  },
  watch: {
    category() {
      this.reload = true;
    },
    timestamp() {
      if (this.reload) {
        setTimeout(() => {
          this.createGraph();
        }, 0);
      } else {
        if (this.evt == null) {
          this.evt = new CustomEvent(this.event_name);
        }
        this.$refs.stacked_bar_percent_chart_div.dispatchEvent(this.evt);
      }
    },
  },
  // inject: ["colors"],
  data() {
    return {
      evt: null,
      reload: false,
      colors: [
        '#d193ff',
        '#00b0f0',
        '#ff5a4e',
        '#94c356',
        '#fcbf21',
        '#cc7a00',
      ]
    };
  },
  methods: {
    createGraph() {
      this.reload = false;

      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);
      am4core.options.autoDispose = true;

      var seriesHeight = 84 / Object.keys(this.graph_data).length;
      seriesHeight = seriesHeight > 24 ? 24 : seriesHeight;

      var chart = am4core.create(
        this.$refs.stacked_bar_percent_chart_div,
        am4charts.XYChart
      );

      // chart.padding(8, 20, 40, 8);
      chart.padding(12, 40, 20, 20);

      Object.entries(this.graph_data).forEach(([key, val]) => {
        chart.data.push({
          label: this.translate[this.translate_key][key],
          key: key,

          a: val.a,
          c: val.c,
          h: val.h,
          o: val.o,
          p: val.p,
          s: val.s,
        });
      });

      this.$refs.stacked_bar_percent_chart_div.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].a = v.a;
              chart.data[index].c = v.c;
              chart.data[index].h = v.h;
              chart.data[index].o = v.o;
              chart.data[index].p = v.p;
              chart.data[index].s = v.s;
            }
          });

          chart.invalidateRawData();
        },
        true
      );

      this.colors.map((color) => {
        chart.colors.list.push(am4core.color(color));
      });

      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";

      chart.legend.itemContainers.template.clickable = false;
      chart.legend.itemContainers.template.focusable = false;
      chart.legend.itemContainers.template.cursorOverStyle =
        am4core.MouseCursorStyle.default;

      chart.legend.useDefaultMarker = true;

      var marker = chart.legend.markers.template.children.getIndex(0);
      marker.cornerRadius(12, 12, 12, 12);
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;

      // Create axes
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "label";
      categoryAxis.renderer.grid.template.opacity = 0;
      categoryAxis.renderer.minGridDistance = 1;

      categoryAxis.renderer.inversed = true;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());

      valueAxis.renderer.grid.template.opacity = 1;
      valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
      valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
      valueAxis.renderer.ticks.template.length = 10;
      valueAxis.renderer.line.strokeOpacity = 0.5;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.renderer.minGridDistance = 20;

      // valueAxis.numberFormatter = new am4core.NumberFormatter();
      // valueAxis.numberFormatter.numberFormat = "# %";

      valueAxis.adjustLabelPrecision = true;

      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;

      function createSeries(field, name) {
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = "label";
        series.stacked = true;
        series.name = name;

        series.columns.template.width = 100;
        series.columns.template.height = seriesHeight;

        series.calculatePercent = false;

        // var labelBullet = series.bullets.push(new am4charts.LabelBullet());
        // labelBullet.locationY = 2.5;
        // labelBullet.label.text = "{valueX}";
        // labelBullet.label.fill = am4core.color("#fff");

        series.columns.template.tooltipText =
          "[bold]{name}[/]\n[bold][font-size: 18px]{valueX} %";
      }

      // Create series
      Object.entries(this.translate.actes).forEach(([key, val]) => {
        createSeries(key, val);
      });
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>